import { render, staticRenderFns } from "./BenchmarkSettings.vue?vue&type=template&id=4333a1a4&scoped=true&"
import script from "./BenchmarkSettings.vue?vue&type=script&lang=ts&"
export * from "./BenchmarkSettings.vue?vue&type=script&lang=ts&"
import style0 from "./BenchmarkSettings.vue?vue&type=style&index=0&id=4333a1a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4333a1a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VMenu,VTextField})
